"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _da = _interopRequireDefault(require("./da.json"));

var _de = _interopRequireDefault(require("./de.json"));

var _en = _interopRequireDefault(require("./en.json"));

var _fr = _interopRequireDefault(require("./fr.json"));

var _el = _interopRequireDefault(require("./el.json"));

var _es = _interopRequireDefault(require("./es.json"));

var _fi = _interopRequireDefault(require("./fi.json"));

var _hi = _interopRequireDefault(require("./hi.json"));

var _id = _interopRequireDefault(require("./id.json"));

var _it = _interopRequireDefault(require("./it.json"));

var _ja = _interopRequireDefault(require("./ja.json"));

var _ko = _interopRequireDefault(require("./ko.json"));

var _mr = _interopRequireDefault(require("./mr.json"));

var _nb = _interopRequireDefault(require("./nb.json"));

var _nl = _interopRequireDefault(require("./nl.json"));

var _pl = _interopRequireDefault(require("./pl.json"));

var _pt = _interopRequireDefault(require("./pt.json"));

var _ru = _interopRequireDefault(require("./ru.json"));

var _sv = _interopRequireDefault(require("./sv.json"));

var _ta = _interopRequireDefault(require("./ta.json"));

var _th = _interopRequireDefault(require("./th.json"));

var _tr = _interopRequireDefault(require("./tr.json"));

var _uk = _interopRequireDefault(require("./uk.json"));

var _vi = _interopRequireDefault(require("./vi.json"));

var _zhSimplified = _interopRequireDefault(require("./zh-simplified.json"));

var _zhTraditional = _interopRequireDefault(require("./zh-traditional.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  'da-DK': _da.default,
  'de-AT': _de.default,
  'de-CH': _de.default,
  'de-DE': _de.default,
  'el-GR': _el.default,
  'en-AE': _en.default,
  'en-AU': _en.default,
  'en-CA': _en.default,
  'en-GB': _en.default,
  'en-HK': _en.default,
  'en-IE': _en.default,
  'en-IL': _en.default,
  'en-IN': _en.default,
  'en-MY': _en.default,
  'en-NZ': _en.default,
  'en-PH': _en.default,
  'en-PK': _en.default,
  'en-SG': _en.default,
  'en-US': _en.default,
  'en-ZA': _en.default,
  'es-AR': _es.default,
  'es-CL': _es.default,
  'es-CO': _es.default,
  'es-ES': _es.default,
  'es-MX': _es.default,
  'es-PE': _es.default,
  'es-US': _es.default,
  'es-VE': _es.default,
  'fi-FI': _fi.default,
  'fr-BE': _fr.default,
  'fr-CA': _fr.default,
  'fr-CH': _fr.default,
  'fr-FR': _fr.default,
  'hi-IN': _hi.default,
  'id-ID': _id.default,
  'it-CH': _it.default,
  'it-IT': _it.default,
  'ja-JP': _ja.default,
  'ko-KR': _ko.default,
  'mr-IN': _mr.default,
  'nb-NO': _nb.default,
  'nl-BE': _nl.default,
  'nl-NL': _nl.default,
  'pl-PL': _pl.default,
  'pt-BR': _pt.default,
  'pt-PT': _pt.default,
  'ru-RU': _ru.default,
  'sv-SE': _sv.default,
  'ta-IN': _ta.default,
  'th-TH': _th.default,
  'tr-TR': _tr.default,
  'uk-UA': _uk.default,
  'vi-VN': _vi.default,
  'zh-HK': _zhTraditional.default,
  'zh-SG': _zhSimplified.default,
  'zh-TW': _zhTraditional.default
};
exports.default = _default;